import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取银行卡信息
export const bankCard = async (params: object) => {
  return await GET({
    url: Api.bankCard,
    params: {
      ...params
    },
    showError: false
  })
}
// 银行卡校验
export const checkBankCard = async (params: object) => {
  return await POST({
    url: Api.checkBankCard,
    params: {
      ...params
    },
    showError: false
  })
}
// 绑定银行卡
// export const bindBankCard = async (params: object) => {
//   return await POST({
//     url: Api.bindBankCard,
//     params: {
//       ...params
//     },
//     showError: false
//   })
// }
// 绑定银行卡
export const addCourierBankCard = async (params: object) => {
  return await POST({
    url: Api.addCourierBankCard,
    data: {
      ...params
    },
    headers: {
      'Content-Type': 'application/json'
    },
    dataType: 'json',
    showError: false
  })
}
// 删除银行卡
export const delCourierBankCard = async (params: object) => {
  return await GET({
    url: Api.delCourierBankCard,
    params: {
      ...params
    },
    showError: false
  })
}
